import { Controller } from "@hotwired/stimulus"

// Auto-removes element after configurable timeout (default 5s).
// Fade-out animation, respects prefers-reduced-motion.

export default class extends Controller {
  static values = { delay: { type: Number, default: 5000 } }

  connect() {
    this.timer = setTimeout(() => this._dismiss(), this.delayValue)
  }

  disconnect() {
    clearTimeout(this.timer)
  }

  dismiss() {
    this._dismiss()
  }

  _dismiss() {
    clearTimeout(this.timer)

    if (this._prefersReducedMotion()) {
      this.element.remove()
    } else {
      this.element.style.transition = "opacity 300ms ease-out"
      this.element.style.opacity = "0"
      this.element.addEventListener("transitionend", () => this.element.remove(), { once: true })
      // Fallback removal
      setTimeout(() => {
        if (this.element.parentNode) this.element.remove()
      }, 350)
    }
  }

  _prefersReducedMotion() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches
  }
}
